/** POST /api/resolve/events/:eventId/assets (`assetTypeId` 1 = clip) */
export const ALARM_CLIP_ASSET_TYPE_ID = 1;

export interface AttachAlarmClipPayload {
  readonly alarmId: string;
  readonly name?: string | null;
  /** NVR wall clock encoded as UTC (`2026-10-19T02:19:35.000Z` = 02:19:35 on the recorder). */
  readonly timestamp?: string | null;
}

export interface AttachAlarmClipRequest {
  readonly assetTypeId: typeof ALARM_CLIP_ASSET_TYPE_ID;
  readonly clip: AttachAlarmClipPayload;
}

/** Response body for attach-alarm-clip POST. */
export interface AttachAlarmClipResponse {
  readonly success: boolean;
  readonly message?: string;
  readonly clipId?: string;
}
